import React, { useEffect } from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const getInitialValue = () =>
  !!JSON.parse(window.localStorage.getItem('rangeOption'));

const CustomCheckBox = ({ className, disabled, label }) => {
  const [checked, setChecked] = React.useState(getInitialValue());

  useEffect(() => {
    window.localStorage.setItem('rangeOption', checked);
  }, [checked]);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
        />
      }
      label={label}
    />
  );
};

export default CustomCheckBox;
